import { render, staticRenderFns } from "./car.vue?vue&type=template&id=5279dff6&scoped=true"
import script from "./car.vue?vue&type=script&lang=js"
export * from "./car.vue?vue&type=script&lang=js"
import style0 from "./car.vue?vue&type=style&index=0&id=5279dff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279dff6",
  null
  
)

export default component.exports